var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NxRadioButton',{attrs:{"label":"Tipo de Pessoa","listOptions":_vm.tipoPessoaOptions,"name":"tipoPessoa"},on:{"update:value":_vm.handleValueUpdate}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2483e64e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-inputs/NxPersonType.vue
// module id = null
// module chunks = 